// ** Third Party Components
import {useTranslation} from 'react-i18next'
import ReactCountryFlag from 'react-country-flag'
import {changeLanguage, getAllowedLocales} from '../../../../utility/LangUtils'

// ** Reactstrap Imports
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from 'reactstrap'

const IntlDropdown = () => {
    // ** Hooks
    const {i18n} = useTranslation()

    const allowedLocales = getAllowedLocales()

    // ** Vars
    const langObj = {
        pl: {
            name: 'Polski',
            countryCode: 'pl'
        },
        en: {
            name: 'English',
            countryCode: 'en'
        }
    }

    const availableOptions = Object.values(langObj).filter(v => allowedLocales.includes(v.countryCode))

    // ** Function to switch Language
    const handleLangUpdate = (e, lang) => {
        e.preventDefault()
        changeLanguage(lang)
        document.documentElement.lang = lang
    }

    return (
        <UncontrolledDropdown href='/' tag='li' className='dropdown-language nav-item'>
            <DropdownToggle href='/' tag='a' className='nav-link' onClick={e => e.preventDefault()}>
                <ReactCountryFlag
                    svg
                    className='country-flag flag-icon'
                    countryCode={i18n.language === 'en' ? 'us' : i18n.language}
                />
                <span className='selected-language'> {langObj[i18n.language].name}</span>
            </DropdownToggle>
            <DropdownMenu className='mt-0' end>
                {availableOptions.map(v => (
                    <DropdownItem key={v.countryCode} href='/' tag='a'
                                  onClick={e => handleLangUpdate(e, v.countryCode)}>
                        <ReactCountryFlag className='country-flag'
                                          countryCode={v.countryCode === 'en' ? 'us' : v.countryCode} svg/>
                        <span className='ms-1'> {v.name}</span>
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    )
}

export default IntlDropdown
